(ns manage.adset-decision-tree-page.view.side-panel.poi.validation
  "POI-specific decision tree validation: detecting outcome triggers that are
  made redundant by the parent node's open-status targeting.")

(def poi-redundant-triggers
  {"open" #{"open-status" "minutes-until-opening"}
   "closed" #{"open-status" "minutes-until-closing"}})

(defn- extract-predicate-triggers
  [predicate]
  (when (sequential? predicate)
    (if (= "and" (first predicate))
      (mapcat extract-predicate-triggers (rest predicate))
      (when-let [macro (second predicate)]
        (when (string? macro)
          (when-let [[_ trigger] (re-find #"\$\{[^.]+\.([^}]+)\}" macro)]
            [trigger]))))))

(defn poi-outcome-has-conflicts?
  [outcome-node parent-node]
  (let [parent-open-status (get-in parent-node [:targeting :context 0 :param :open-status])
        conflicts (get poi-redundant-triggers parent-open-status)]
    (when (seq conflicts)
      (let [triggers (set (extract-predicate-triggers (get-in outcome-node [:targeting :predicate])))]
        (some conflicts triggers)))))
